import stevenImage from "../assets/Steven.png";
import zhangImage from "../assets/Zhang.png";
import TaliaImage from "../assets/Talia.png";
import XiongImage from "../assets/Xiong.png";

const coachesData = [
  {
    id: 1,
    name: "coach.id_1.name",
    title: "coach.id_1.title",
    description:
      "coach.id_1.description",
    image: stevenImage,
  },
  {
    id: 2,
    name: "coach.id_2.name",
    title: "coach.id_2.title",
    description:
      "coach.id_2.description",
    image: zhangImage,
  },
  {
    id: 3,
    name: "coach.id_3.name",
    title: "coach.id_3.title",
    description:
      "coach.id_3.description",
    image: XiongImage,
  },
  {
    id: 4,
    name: "coach.id_4.name",
    title: "coach.id_4.title",
    description:
      "coach.id_4.description",
    image: TaliaImage,
  },
];

export default coachesData;
